import { render } from "./UserNotification.vue?vue&type=template&id=6b8944f4&ts=true"
import script from "./UserNotification.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserNotification.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UserNotification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b8944f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b8944f4', __exports__)) {
    api.reload('6b8944f4', __exports__)
  }
  
  module.hot.accept("./UserNotification.vue?vue&type=template&id=6b8944f4&ts=true", () => {
    api.rerender('6b8944f4', render)
  })

}


export default __exports__